
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zh/faq",
      function () {
        return require("private-next-pages/zh/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zh/faq"])
      });
    }
  